import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createAgent } from 'redux/modules/model/agent'
import { listClients } from 'redux/modules/model/client'
import { clientsSelector } from 'redux/selectors'
import { AgentForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class AgentAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createAgent: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients } = this.props
    listClients({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createAgent } = this.props
    return formSubmit(createAgent, { ...values })
      .then(() => history.push(ROUTES.AGENT))
  };

  render() {
    const { clientList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.AGENT}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new agent</PageContentTitle>
          <AgentForm onSubmit={this.handleSubmit} clients={clientList} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector
})

export const actions = {
  createAgent,
  listClients
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(AgentAdd)



// WEBPACK FOOTER //
// ./src/pages/agent/agent-add/index.js